import SocketFactory from '@/drivers/socket'
import { loadImage } from '@/utils/load-image'

import type { PrinterConfig, PrinterDriver } from '../types'
import { EscPosEncoder } from './esc-pos-encoder'

export default class EscPos implements PrinterDriver {
  private config: PrinterConfig & { matrixMode?: boolean }

  constructor(config: PrinterConfig & { matrixMode?: boolean }) {
    this.config = config
  }

  printImage(imageData: string) {
    return new Promise<void>((resolve, reject) => {
      const rejectMiddleware = (error: unknown) => {
        reject(error)
      }
      const socket = SocketFactory.getSocket()
      const config = this.config
      socket.open(
        this.config.address,
        9100,
        async () => {
          const img = await loadImage(imageData)

          const width = config.matrixMode ? 200 : 504
          const ratio = width / img.width
          const height = Math.round((img.height * ratio) / 8) * 8

          const encoder = new EscPosEncoder()
          encoder.align('center')
          if (config.matrixMode) {
            encoder.imageEsc(img, width, height)
          } else {
            encoder.image(img, width, height)
          }

          const result = encoder.newline(5).cut('partial').encode()

          socket.write(
            result,
            () => {
              socket.shutdownWrite(() => {
                resolve()
              }, rejectMiddleware)
            },
            rejectMiddleware
          )
        },
        rejectMiddleware
      )
    })
  }

  openCashDrawer() {
    return new Promise<void>((resolve, reject) => {
      const socket = SocketFactory.getSocket()
      socket.open(
        this.config.address,
        9100,
        () => {
          const encoder = new EscPosEncoder()
          const result = encoder.openCashDrawer().encode()

          socket.write(
            result,
            () => {
              socket.shutdownWrite(() => {
                resolve()
              }, reject)
            },
            reject
          )
        },
        reject
      )
    })
  }

  getStatus() {
    return new Promise<any | null>((resolve, reject) => {
      const socket = SocketFactory.getSocket()
      socket.open(
        this.config.address,
        9100,
        () => {
          const encoder = new EscPosEncoder()
          const result = encoder.status().encode()
          socket.write(result, () => {}, reject)
        },
        reject
      )
      socket.onData(data => {
        socket.shutdownWrite(() => {
          resolve(data)
        }, reject)
      })
      setTimeout(() => {
        socket.shutdownWrite(() => {
          resolve(null)
        }, reject)
      }, 2000)
    })
  }
}
